import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M13.333 13.333h-8a3.28 3.28 0 0 0 .667-2v-2h4A.667.667 0 1 0 10 8H6V5.927A3.26 3.26 0 0 1 12.087 4.3a.667.667 0 0 0 .913.24.667.667 0 0 0 .247-.907 4.6 4.6 0 0 0-8.58 2.294V8h-2a.667.667 0 0 0 0 1.333h2v2a2 2 0 0 1-2 2 .667.667 0 0 0 0 1.334h10.666a.667.667 0 0 0 0-1.334"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })